import React, { useCallback } from 'react';

// store
import { storeSet, useStoreValue } from '../../store';

// components
import ButtonIconQuickAction from '../ButtonWrapper/components/ButtonIconQuickAction';
import ArrowIcon from '../../icons/ArrowIcon';
import ScissorsIcon from '../../icons/ScissorsIcon';
import ButtonIconQuickRadioAction from '../ButtonWrapper/components/ButtonIconQuickRadioAction';
import UndoIcon from '../../icons/UndoIcon';
import RedoIcon from '../../icons/RedoIcon';
import MagnetIcon from '../../icons/MagnetIcon';
import TcIcon from '../../icons/TcIcon';

const QuickActionsPanel = ({ undo, redo, canUndo = false, canRedo = false, undoLabel = null, redoLabel = null }) => {
    const timelineEditingMode = useStoreValue('timelineEditingMode');

    // Undo/Redo action functions
    const undoAction = () => {
        if (canUndo && undo) {
            undo();
        }
    };

    const redoAction = () => {
        if (canRedo && redo) {
            redo();
        }
    };

    const arrowModeAction = () => {
        storeSet('timelineEditingMode', timelineEditingMode !== 'arrow' ? 'arrow' : '')
    };

    const cutModeAction = useCallback(() => {
        storeSet('timelineEditingMode', timelineEditingMode !== 'cut' ? 'cut' : '')
    }, [timelineEditingMode]);

    const handleAction5 = () => {};

    const handleAction6 = () => {};

    return (
        <div className="timeline-quick-actions">
            <ButtonIconQuickAction onClick={undoAction} disabled={!canUndo} title={undoLabel ? `Undo: ${undoLabel}` : 'Undo'}>
                <UndoIcon/>
            </ButtonIconQuickAction>
            <ButtonIconQuickAction onClick={redoAction} disabled={!canRedo} title={redoLabel ? `Redo: ${redoLabel}` : 'Redo'}>
                <RedoIcon/>
            </ButtonIconQuickAction>
            <ButtonIconQuickRadioAction onChange={arrowModeAction} checked={timelineEditingMode === 'arrow'} title="Arrow mode">
                <ArrowIcon/>
            </ButtonIconQuickRadioAction>
            <ButtonIconQuickRadioAction onChange={cutModeAction} checked={timelineEditingMode === 'cut'} title="Cut mode">
                <ScissorsIcon/>
            </ButtonIconQuickRadioAction>
            <ButtonIconQuickAction onClick={handleAction5}>
                <MagnetIcon/>
            </ButtonIconQuickAction>
            <ButtonIconQuickAction onClick={handleAction6}>
                <TcIcon/>
            </ButtonIconQuickAction>
        </div>
    );
};

export default QuickActionsPanel;
